import { LabelProps } from "@king-ict/eupisi-ui/components";

import { Address } from "../models";
import { CommitteeStatus } from "../models/Committee";
import {
  CommitteeEnrollmentDecision,
  OutsideEnrollmentAreaStatus,
  RequestStatus,
  RequestType,
} from "../models/Request";
import {
  SchoolCandidateSentStatus,
  SchoolCandidateStatus,
} from "../models/SchoolCandidate";

export function getCommitteeStatusColor(statusId: CommitteeStatus): any {
  switch (statusId) {
    case CommitteeStatus.NotDefined:
      return ""; // gray
    case CommitteeStatus.Inactive:
      return "noted-2"; // gray
    case CommitteeStatus.ConfirmationRequired:
      return "info"; // blue
    case CommitteeStatus.Granted:
      return "success"; // green
    case CommitteeStatus.Rejected:
      return "danger"; // red
    default:
      return "";
  }
}
export function getSchoolCandidateStatusColor(
  statusId?: SchoolCandidateStatus
): any {
  if (!statusId) return "";

  switch (statusId) {
    case SchoolCandidateStatus.notSent:
      return "";
    case SchoolCandidateStatus.onSchoolList:
      return "success";
    case SchoolCandidateStatus.confirmation:
      return "danger";
    default:
      return "";
  }
}
export function getSchoolCandidateSentStatusColor(statusId: number): any {
  switch (statusId) {
    case SchoolCandidateSentStatus.NotSent:
      return "";
    case SchoolCandidateSentStatus.PartlySent:
    case SchoolCandidateSentStatus.ConfirmationRequired:
      return "warning";
    case SchoolCandidateSentStatus.Sent:
      return "success";
    default:
      return "";
  }
}

export const getRequestStatusColor = (status: RequestStatus) => {
  var color: LabelProps["color"];
  switch (status) {
    case RequestStatus.Draft:
      color = "noted-2";
      break;
    case RequestStatus.Submitted:
    case RequestStatus.ProcedureSubmitted:
      color = "primary"; // green
      break;
    case RequestStatus.Cancelled:
      color = "danger"; // green
      break;
    case RequestStatus.Registered:
      color = "success"; // yellow
      break;
    case RequestStatus.DecisionOnAppropriateProgram:
    case RequestStatus.DecisionOnEnrollmentPostponement:
    case RequestStatus.EnrollmentApproved:
    case RequestStatus.EnrollmentConfirmed:
    case RequestStatus.OnSchoolCandidateList:
    case RequestStatus.OpinionWithRecommendation:
    case RequestStatus.ProcedureApproved:
    case RequestStatus.RegistrationFormCreated:
    case RequestStatus.RegistrationFormCreating:
      //case RequestStatus.RegistrationSigned:
      color = "warning"; // yellow
      break;
    default:
      color = "noted-2";
  }
  return color;
};
export const getRequestTypeColor = (type: RequestType): any => {
  var color: LabelProps["color"];
  switch (type) {
    case RequestType.RegularEnrollment:
      color = "success"; // green
      break;
    case RequestType.RegularEnrollmentForChildrenWithLearningDifficulties:
    case RequestType.EarlyEnrollment:
    case RequestType.TemporaryExemption:
      color = "warning"; // yellow
      break;
  }
  return color;
};
export const getOutsideEnrollmentAreaStatusColor = (
  d?: OutsideEnrollmentAreaStatus | null
): LabelProps["color"] => {
  let color: LabelProps["color"] = "danger"; // provide a default

  switch (d) {
    case OutsideEnrollmentAreaStatus.NotProcessed:
      color = undefined;
      break;
    case OutsideEnrollmentAreaStatus.SuggestedEnrollmentAccepted:
      color = "warning"; // yellow
      break;
    case OutsideEnrollmentAreaStatus.Decision:
      color = "success"; // green
      break;
    default:
      color = "danger"; // red
  }

  return color;
};
export const getCommitteeEnrollmentDecisionColor = (
  d: CommitteeEnrollmentDecision
): any => {
  var color = "danger"; // provide a default
  switch (d) {
    case CommitteeEnrollmentDecision.Ready:
      color = "success"; // green
      break;
  }
  return color;
};

export const getAddressString = (
  address?: Address | null,
  alternateAddress?: string | null
): string => {
  var result = "";
  if (address) {
    if (address.street) result += address.street;
    if (address.houseNumber) result += " " + address.houseNumber + ",";
    if (address.town) result += " " + address.town;
  } else {
    result += alternateAddress ?? "-";
  }
  return result;
};

export const formatDate = (date?: Date | string | null): string => {
  if (!date) return "";

  return new Date(date).toLocaleString("hr-HR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatToISOString = (date?: Date | null) => {
  if (!date) return null;

  return new Date(date).toISOString();
};

export const setDateToUTCMidnight = (date: Date | null) => {
  if (!date) return null;

  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
};
